import {Action} from '@ngrx/store';
import {GetUserRequest, PostUserRequest, User} from '../models/user';
import {ErrorPayload} from '../models/general';

export enum UserActionTypes {
  GetUser = '[User] Get User',
  GetUserComplete = '[User] Get User Complete',
  GetUserError = '[User] Get User Error',
  PostUser = '[User] Post User',
  PostUserComplete = '[User] Post User Complete',
  PostUserError = '[User] Post User Error'
}

export class GetUser implements Action {
  readonly type = UserActionTypes.GetUser;

  constructor(public payload: GetUserRequest) {
  }
}

export class GetUserComplete implements Action {
  readonly type = UserActionTypes.GetUserComplete;

  constructor(public payload: User) {
  }
}

export class GetUserError implements Action {
  readonly type = UserActionTypes.GetUserError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostUser implements Action {
  readonly type = UserActionTypes.PostUser;

  constructor(public payload: PostUserRequest) {
  }
}

export class PostUserComplete implements Action {
  readonly type = UserActionTypes.PostUserComplete;
}

export class PostUserError implements Action {
  readonly type = UserActionTypes.PostUserError;

  constructor(public payload: ErrorPayload) {
  }
}

export type UserActions =
  | GetUser
  | GetUserComplete
  | GetUserError
  | PostUser
  | PostUserComplete
  | PostUserError;
